'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var PropTypes = _interopDefault(require('prop-types'));
var functions = require('@keytrade/functions');
var React = _interopDefault(require('react'));
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var colors = functions.config.colors.list;
var RangeIndicatorWrapper = styled.div.withConfig({
  displayName: "RangeIndicatorstyled__RangeIndicatorWrapper",
  componentId: "sc-64iugg-0"
})(["width:100%;"]);
var LabelsWrapper = styled.div.withConfig({
  displayName: "RangeIndicatorstyled__LabelsWrapper",
  componentId: "sc-64iugg-1"
})(["display:flex;justify-content:space-between;margin-top:15px;align-items:flex-end;"]);
var FlexLabel = styled.div.withConfig({
  displayName: "RangeIndicatorstyled__FlexLabel",
  componentId: "sc-64iugg-2"
})(["flex:1 1 auto;"]);
var FlexLabelReverse = styled.div.withConfig({
  displayName: "RangeIndicatorstyled__FlexLabelReverse",
  componentId: "sc-64iugg-3"
})(["flex:1 1 auto;text-align:right;"]);
var RangeProgressBar = styled.div.withConfig({
  displayName: "RangeIndicatorstyled__RangeProgressBar",
  componentId: "sc-64iugg-4"
})(["background-color:", ";border-radius:", ";flex:1 1 100%;height:", ";max-width:100%;overflow:hidden;position:relative;width:100%;z-index:1;display:block;"], function (props) {
  return colors[props.bgColor] || colors.GreyLight;
}, function (props) {
  return props.radius;
}, function (props) {
  return props.height;
});
RangeProgressBar.propTypes = {
  bgColor: PropTypes.string,
  radius: PropTypes.string,
  height: PropTypes.string
};
RangeProgressBar.defaultProps = {
  radius: '0',
  height: '1rem'
};
RangeProgressBar.docProps = {
  bgColor: 'fill color',
  radius: 'radius of the progressBar',
  height: 'height of the progressBar'
};
var RangeProgressStatus = styled.div.withConfig({
  displayName: "RangeIndicatorstyled__RangeProgressStatus",
  componentId: "sc-64iugg-5"
})(["background-color:", ";height:100%;position:relative;width:", ";z-index:2;"], function (props) {
  return colors[props.bgColor] || colors.BlueSky;
}, function (props) {
  return "calc(100% * ".concat(props.value, " / (").concat(props.valueMax, " - ").concat(props.valueMin, "))");
});
RangeProgressStatus.propTypes = {
  bgColor: PropTypes.string,
  value: PropTypes.number,
  valueMax: PropTypes.number,
  valueMin: PropTypes.number
};
RangeProgressStatus.defaultProps = {
  value: 0,
  valueMax: 100,
  valueMin: 0
};
RangeProgressStatus.docProps = {
  bgColor: 'fill color',
  value: 'current value',
  valueMax: 'max value',
  valueMin: 'max value'
};
var colors$1 = functions.config.colors.list;
var RangeIndicator = function RangeIndicator(_ref) {
  var bgColor = _ref.bgColor,
    ProgressBarColor = _ref.ProgressBarColor,
    height = _ref.height,
    labelMax = _ref.labelMax,
    labelMin = _ref.labelMin,
    value = _ref.value,
    valueMax = _ref.valueMax,
    valueMin = _ref.valueMin,
    radius = _ref.radius;
  if (valueMin > valueMax) throw new Error('valueMin must be smaller than valueMax or equals');
  return /*#__PURE__*/React.createElement(RangeIndicatorWrapper, null, /*#__PURE__*/React.createElement(RangeProgressBar, {
    height: height,
    radius: radius,
    bgColor: bgColor
  }, /*#__PURE__*/React.createElement(RangeProgressStatus, {
    valueMax: valueMax,
    valueMin: valueMin,
    value: value,
    bgColor: ProgressBarColor
  })), (labelMin || labelMax) && /*#__PURE__*/React.createElement(LabelsWrapper, null, labelMin && /*#__PURE__*/React.createElement(FlexLabel, null, labelMin), labelMax && /*#__PURE__*/React.createElement(FlexLabelReverse, null, labelMax)));
};
RangeIndicator.defaultProps = {
  ProgressBarColor: colors$1.BlueSky,
  bgColor: colors$1.GreyLight,
  height: '1rem',
  value: 20,
  valueMax: 100,
  valueMin: 0
};
exports.RangeIndicator = RangeIndicator;